import { Box, Button, Typography } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import Divider from "@mui/material/Divider";
import LaptopWindowsIcon from "@mui/icons-material/LaptopWindows";
import IphoneApp from "./IphoneApp";
import { ToastContainer } from "react-toastify";

const MobileLanding = ({ browserName }) => {
  return (
    <Box
      sx={{
        paddingTop: "50px",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        textAlign: "center",
        width: "100%",
        height: "100%",
        backgroundColor: "#091057",
      }}
    >
      <Typography
        variant="h5"
        style={{
          color: "#EC8305",
          fontWeight: "bolder",
          textAlign: "center",
          marginBottom: "25px",
        }}
      >
        یادگیری زبان با فیلم و سریال
      </Typography>
      <a target="_blank" href="https://cafebazaar.ir/app/com.umlang">
        <img style={{ width: "150px", margin: 3 }} src="img/apk/bazar.png" />
      </a>
      <a target="_blank" href="https://app.umlang.com/dl/umlang.apk">
        <img style={{ width: "150px", margin: 3 }} src="img/apk/direct.png" />
      </a>
      <IphoneApp />
      <Divider
        textAlign="right"
        variant="fullWidth"
        sx={{
          borderBottomWidth: 5,
          backgroundColor: "#DBD3D3",
          marginTop: "50px",
        }}
      />

      <Typography
        style={{
          color: "#DBD3D3",
          fontSize: "15px",
          marginTop: "10px",
          paddingLeft: "10px",
          paddingRight: "10px",
        }}
      >
        توجه: برای دریافت و نصب برنامه در کامپیوتر یا لپ تاپ سایت را با مرورگر
        Chrome یا Edge باز کنید
      </Typography>
      <LaptopWindowsIcon color="success" fontSize="large" />
      <br />
      <img
        style={{ maxWidth: "70%", height: "auto" }}
        alt="یادگیری زبان با فیلم و سریال"
        src={`${process.env.REACT_APP_SITEURL}/img/startimg.png`}
      />
      <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </Box>
  );
};

export default MobileLanding;
